module.exports = __webpack_public_path__ + "media/images/hejkdwcj-91a005c5ca6dd7d4f3595fe70c15a2d2.webp";